import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import mapboxgl from 'mapbox-gl'; // or "const mapboxgl = require('mapbox-gl');"
 
mapboxgl.accessToken = 'pk.eyJ1Ijoib3NjYXJmcGF0YSIsImEiOiJjbGRxN2dkNDgwMTVkM29rZ2ZzNzFmY3A0In0.P3iRtuCzBq2opwTqrD8YQg';



if ( ! navigator.geolocation )  {
    alert('Tu navegador no tiene geoLocalizacion')
    throw new Error('Geolocation isnt enabled')
}



createApp(App).use(store).use(router).mount('#app')
